import ScheduleDemoFormSuccess from './ScheduleDemoFormSuccess';

export default ScheduleDemoFormSuccess;
